import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import routes from '../../../../routes';
import { NoResult, Text } from '../../../atoms';
import { DocumentsGrid, Legend } from '../../../../app/pages/Documents/style';
import SortBy from '../../../atoms/SortBy';
import CardInnerDocuments from '../../../atoms/Cards/CardInnerDocuments';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { objectArraySorting } from '../../../../utils/common';

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 40px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column-reverse;
    align-items: start;
    gap: 16px;
  }
`;

const CourseDocuments = ({ mediaIsPhone, mediaIsTablet, documents }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (documents?.length > 0) {
      setItems(documents);
    }
  }, [documents]);

  const sortBy = (sorting) => {
    const newItems = [...(documents || [])];
    if (sorting === 'alphabetical') {
      objectArraySorting(newItems, 'title');
    } else {
      objectArraySorting(newItems, 'last_saved');
    }
    setItems(newItems);
  };

  return (
    <div>
      <Text type="h1.5" mb={16}>
        Documenti del corso
      </Text>
      <Actions>
        <Text type="b2">{documents?.length ?? 0} documenti disponibili</Text>
        <SortBy
          onChange={(v) => {
            // setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
            sortBy(v?.value);
          }}
        />
      </Actions>
      {items?.length > 0 ? (
        <>
          {!(mediaIsPhone || mediaIsTablet) && (
            <Legend className="inner-documents">
              <p>FORMATO</p>
              <p>TITOLO </p>
              <p>TIPOLOGIA </p>
              <p>DATA</p>
              <p>DIMENSIONI</p>
            </Legend>
          )}
          <DocumentsGrid className="pb-0">
            {(items || []).map((item) => (
              <CardInnerDocuments
                key={`document-${item?.id}`}
                item={item}
                onClick={() =>
                  navigate(`${routes.documentDetails.path}/${item.id}`)
                }
              />
            ))}
          </DocumentsGrid>
        </>
      ) : (
        <NoResult />
      )}
    </div>
  );
};

CourseDocuments.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  documents: PropTypes.array,
};

export default connect(
  (state) => {
    const { inner_documents: documents } = state.coursedetails;
    return {
      documents,
    };
  },
  (dispatch) => ({})
)(withMediaQueries(CourseDocuments));
